import { AccountRequisites } from "@/modules/account/components";
import { useLazyDownloadAccountRequisiteQuery } from "@/modules/account/services";
import { PageHeader } from "@/shared/components";
import { useNotify } from "@/shared/hooks";
import { downloadFileFromUrl } from "@/shared/utils";
import { Button } from "@ab.uitools/ui-library/components/Button";
import { Spinner } from "@ab.uitools/ui-library/components/Spinner";
import { IconArrowDownload } from "@ab.uitools/ui-library/components/SVGIcons";
import { Text } from "@ab.uitools/ui-library/components/Text";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

export const AccountRequisitesPage = () => {
  const { accountId = "" } = useParams();
  const { t } = useTranslation();
  const { showErrorSnackbar } = useNotify();
  const [downloadRequisite, { isFetching }] = useLazyDownloadAccountRequisiteQuery();

  const onDownloadAccountRequisite = () => {
    downloadRequisite({ accountId })
      .unwrap()
      .then((response) => {
        if (response?.url) {
          const name = `Account-requisite-${accountId}.pdf`;
          downloadFileFromUrl(response.url, name);
        }
      })
      .catch((error) => {
        showErrorSnackbar(error);
      });
  };

  return (
    <div className="full-width page-container">
      <PageHeader>
        <Button
          className="flexbox align-items--center"
          onClick={onDownloadAccountRequisite}
          data-testid="download-account-requisite"
          data-ga-id="download-account-requisite"
          data-ga-action="Download account requisite"
          buttonText={
            <div className="flexbox align-items--center">
              {isFetching ? (
                <Spinner type="inverse" className="spinner-icon" isFullScreen={false} size="small"/>
              ) : <IconArrowDownload type="inverse"/>}
              <Text type="inverse" className="pl-6">{t("general.exportPdf")}</Text>
            </div>
          }
        />
      </PageHeader>
      <div className="full-width flexbox justify-content--center h-fit-content page-body">
        <AccountRequisites/>
      </div>
    </div>
  );
};
